import MarqueeRibbon from "react-fast-marquee";

const WORDS = ["Strategy", "Transformation", "Finance", "Advisory", "B2B Marketplace"];

export default function Ticker() {
  return (
    <div data-testid="editorial-marquee" className="border-y border-[#E5E5DE] py-5 overflow-hidden">
      <MarqueeRibbon speed={30} gradient={false} pauseOnHover>
        {WORDS.concat(WORDS).map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-xl md:text-2xl text-[#16180F]/60 px-14">{w}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#4C8C1E]" />
          </span>
        ))}
      </MarqueeRibbon>
    </div>
  );
}
